module.exports = __webpack_public_path__ + "img/rotate-ccw.0df58ca9.svg";